// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_web__Web_usage_model from "./web_usage_model.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__Float from "melange/float.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function number(value) {
  const n = Js__Js_json.decodeNumber(value);
  if (n !== undefined) {
    if (Stdlib__Float.is_finite(n) && n >= 0) {
      return n;
    }
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_session_usage_response"
      });
  }
  throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
      MEL_EXN_ID: Mapre_wire__Json.Invalid,
      _1: "invalid_session_usage_response"
    });
}

function optional_number(value) {
  if (Caml_obj.caml_equal(value, null)) {
    return;
  } else {
    return number(value);
  }
}

function optional(json, key) {
  const value = Mapre_wire__Json.get(json, key);
  if (Caml_obj.caml_equal(value, null)) {
    return;
  } else {
    return Mapre_wire__Json.string(json, key);
  }
}

function $$boolean(json, key) {
  const value = Js__Js_json.decodeBoolean(Mapre_wire__Json.get(json, key));
  if (value !== undefined) {
    return value;
  }
  throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
      MEL_EXN_ID: Mapre_wire__Json.Invalid,
      _1: "invalid_session_usage_response"
    });
}

function count(json, key) {
  const n = Mapre_wire__Json.integer(json, key);
  if (n < 0) {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_session_usage_response"
      });
  }
  return n;
}

function bounded(json, key, max) {
  const rows = Mapre_wire__Json.array(json, key);
  if (rows.length > max) {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_session_usage_response"
      });
  }
  return Stdlib__Array.to_list(rows);
}

function categories(json) {
  const partial_arg = Mapre_wire__Json.get(json, "categories");
  return Stdlib__List.map((function (param) {
    return Mapre_web__Web_usage_model.category(partial_arg, param);
  }), {
    hd: "compute",
    tl: {
      hd: "model",
      tl: {
        hd: "snapshot",
        tl: {
          hd: "proxy",
          tl: /* [] */ 0
        }
      }
    }
  });
}

function run(json) {
  number(Mapre_wire__Json.get(json, "created_at"));
  const value = Mapre_wire__Json.get(json, "collection");
  const collection = Caml_obj.caml_equal(value, null) ? undefined : ({
      state: Mapre_wire__Json.string(value, "state"),
      attempts: count(value, "attempts"),
      error: optional(value, "last_error")
    });
  return {
    id: Mapre_wire__Json.string(json, "run_id"),
    state: Mapre_wire__Json.string(json, "state"),
    collection
  };
}

function decode(session, json) {
  if (Mapre_wire__Json.string(json, "session_id") !== session) {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_session_usage_response"
      });
  }
  const counts = Mapre_wire__Json.get(json, "collections");
  const collections = Stdlib__String.concat(", ", Stdlib__List.map((function (key) {
    return String(count(counts, key)) + (" " + key);
  }), {
    hd: "pending",
    tl: {
      hd: "recorded",
      tl: {
        hd: "unattributed",
        tl: {
          hd: "exhausted",
          tl: /* [] */ 0
        }
      }
    }
  }));
  return {
    categories: categories(json),
    collections,
    runs: Stdlib__List.map(run, bounded(json, "runs", 25)),
    truncated: $$boolean(json, "runs_truncated")
  };
}

function source(json) {
  const evidence = Mapre_wire__Json.get(json, "evidence");
  const fields = Js__Js_json.decodeObject(evidence);
  let fields$1;
  if (fields !== undefined) {
    fields$1 = Caml_option.valFromOption(fields);
  } else {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_session_usage_response"
      });
  }
  const evidence$1 = Stdlib__List.filter_map((function (key) {
    return Stdlib__Option.bind(Js__Js_dict.get(fields$1, key), (function (value) {
      return Stdlib__Option.map((function (text) {
        return [
          key,
          text
        ];
      }), Js__Js_json.decodeString(value));
    }));
  }), {
    hd: "kind",
    tl: {
      hd: "request_id",
      tl: {
        hd: "agent",
        tl: {
          hd: "model",
          tl: {
            hd: "basis",
            tl: {
              hd: "resource_id",
              tl: /* [] */ 0
            }
          }
        }
      }
    }
  });
  const rows = Stdlib__List.map((function (row) {
    return [
      Mapre_wire__Json.string(row, "category"),
      {
        unit: Mapre_wire__Json.string(row, "unit"),
        value: number(Mapre_wire__Json.get(row, "quantity"))
      },
      optional_number(Mapre_wire__Json.get(row, "amount_microusd"))
    ];
  }), bounded(json, "rows", 100));
  number(Mapre_wire__Json.get(json, "occurred_at"));
  return {
    id: Mapre_wire__Json.string(json, "source_id"),
    connection: optional(json, "connection_id"),
    owner: optional(json, "owner_id"),
    consumer: optional(json, "consumer_id"),
    first_run: optional(json, "first_run_id"),
    evidence: evidence$1,
    rows
  };
}

function decode_detail(session, run_id, json) {
  if (Mapre_wire__Json.string(json, "session_id") !== session) {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_session_usage_response"
      });
  }
  const value = Mapre_wire__Json.get(json, "run");
  const run$1 = run(value);
  if (run$1.id !== run_id) {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_session_usage_response"
      });
  }
  return {
    run: run$1,
    categories: categories(value),
    sources: Stdlib__List.map(source, bounded(json, "sources", 100)),
    truncated: $$boolean(json, "sources_truncated")
  };
}

function update(t, selected) {
  if (/* tag */ typeof selected !== "object" && typeof selected !== "function") {
    return t;
  }
  switch (selected.TAG) {
    case /* Loading */ 1 :
      return {
        report: t.report,
        detail: undefined,
        selected: selected._0,
        loading: true,
        message: ""
      };
    case /* Loaded */ 2 :
      return {
        report: selected._0,
        detail: undefined,
        selected: undefined,
        loading: false,
        message: ""
      };
    case /* Detailed */ 3 :
      return {
        report: t.report,
        detail: selected._0,
        selected: t.selected,
        loading: false,
        message: ""
      };
    case /* Failed */ 4 :
      return {
        report: undefined,
        detail: undefined,
        selected: t.selected,
        loading: false,
        message: selected._0
      };
    default:
      return t;
  }
}

const initial = {
  report: undefined,
  detail: undefined,
  selected: undefined,
  loading: false,
  message: ""
};

export {
  initial,
  decode,
  decode_detail,
  update,
}
/* Mapre_web__Web_usage_model Not a pure module */
